import {
  ActivatedRouteSnapshot,
  CanActivateFn,
  Router,
  RouterStateSnapshot,
} from '@angular/router';
import { AuthService } from '../../services/api/auth/auth.service';
import { inject } from '@angular/core';
import { AppState } from '../../../store/app.state';
import { Store } from '@ngrx/store';
import { selectUser } from '../../../store/auth/auth.selectors';
import { map, take } from 'rxjs';

export const roleGuard = (allowedRoles: string[]): CanActivateFn => {
  return (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
    const store = inject(Store<AppState>);
    const router = inject(Router);

    return store.select(selectUser).pipe(
      take(1),
      map((user) => {
        if (!user) {
          router.navigate(['/login']);
          return false;
        }

        const hasRole = user.roles?.some((role) => allowedRoles.includes(role));
        if (!hasRole) {
          router.navigate(['/unauthorized']);
          return false;
        }

        return true;
      })
    );
  };
};
